import { useDispatch, useSelector } from "react-redux"
import {WiMoonAltWaningGibbous6} from "react-icons/wi"
import {IoIosMoon} from "react-icons/io"
import {BsMoonFill, BsFillSunFill} from "react-icons/bs"
import styled from "styled-components"
import { handleTheme, themeDropdown, topbarDropdown } from "../../../../features/layout/layoutSlice"
const Container = styled.div`
    width: 185px;
    height: auto;
    background-color: ${({ theme }) => theme.mainBgColor};
    position: absolute;
    top: 40px;
    left: -100px;
    z-index: 10;
    border-radius: 10px;
    padding: 15px 20px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    color: ${({ theme }) => theme.mainTextColor};
    border: 1px solid ${({theme}) => theme.mainBorderColor};

    @media only screen and (max-width: 1550px) {
        top: 65px;
        right: 0;
        left: initial;
    }

    .item{
        padding: 5px 10px;
        border-radius: 10px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 5px;

        &:hover{
            background-color: ${({theme}) => theme.secondaryBgColor};
        }

        .icon{
            width: 16px;
            height: 16px;
        }
 
    }
    .active{
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        }

`
const TopbarThemeDropdown = () => {

    const dispatch = useDispatch()
    const {themeRef} = useSelector((state)=> state.layout)

    const handleClick = (type) => {
        dispatch(handleTheme(type))
        dispatch(themeDropdown())
        dispatch(topbarDropdown())
    }

  return (
    <Container>
        <div className={`item ${themeRef === "system" && "active"}`} onClick={()=> handleClick("system")}>
            <WiMoonAltWaningGibbous6 className="icon"/>
            <span>Cihaz Teması</span>
        </div>
        <div className={`item ${themeRef === "light" && "active"}`} onClick={()=> handleClick("light")}>
            <BsFillSunFill className="icon"/>
            <span>Açık Tema</span>
        </div>
        <div className={`item ${themeRef === "dark" && "active"}`} onClick={()=> handleClick("dark")}>
            <BsMoonFill className="icon"/>
            <span>Koyu Tema</span>
        </div>
    </Container>
  )
}

export default TopbarThemeDropdown